import { render, staticRenderFns } from "./collectActivity.vue?vue&type=template&id=34aa652c&scoped=true&"
import script from "./collectActivity.vue?vue&type=script&lang=js&"
export * from "./collectActivity.vue?vue&type=script&lang=js&"
import style0 from "./collectActivity.vue?vue&type=style&index=0&id=34aa652c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aa652c",
  null
  
)

export default component.exports